<template>
    <div>
        <b-row class="mb-3">
            <b-col sm="12" md="6">
                <label>{{ $t('Director Name') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="params.directorName" @keydown="onChange('directorName')"/>
                <div v-if="error['directorName']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorName'])}}
                </div>
            </b-col>
            <b-col sm="12" md="6">
                <label>{{ $t('Director ID Number') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="params.directorIdNo" @keydown="onChange('directorIdNo')"/>
                <div v-if="error['directorIdNo']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorIdNo'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col sm="12" md="6">
                <label>{{ $t('Director Birth Date') }} <span class="text-danger">*</span></label>
                <date-picker v-model="params.directorBirthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('directorBirthDate')"></date-picker>
                <div v-if="error['directorBirthDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorBirthDate'])}}
                </div>
            </b-col>
            <b-col sm="12" md="6">
                <label>{{ $t("Type of director's ID") }} <span class="text-danger">*</span></label>
                <NewDocOption 
                    :data="doc_type_list"
                    :ref="'doc_type'"
                    @selected-document="selectedDocument($event)">
                </NewDocOption>
                <div v-if="error['directorIdType']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorIdType'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="6" class="mb-3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(doc_type==0?'ic':'passport')+'_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>

                <FileUploader  
                    :type="'browse'"
                    :ref="'directorIdFront'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    :default_image="params.directorIdFront"
                    @capture-file="captureFile($event,'directorIdFront')" 
                    @remove-image="removeImage($event,'directorIdFront')"
                    @toggle-camera="toggleCamera($event)">
                </FileUploader>
                <div v-if="error['directorIdFront']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorIdFront'])}}
                </div>
            </b-col>

            <b-col cols="12" md="6" v-if="params.directorIdType == 3 || params.directorIdType == 4 || params.directorIdType == 5" class="mb-3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(doc_type==0?'ic':'passport')+'_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>
                <FileUploader  
                    :type="'browse'"
                    :ref="'directorIdReverse'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    :default_image="params.directorIdReverse"
                    @capture-file="captureFile($event,'directorIdReverse')" 
                    @remove-image="removeImage($event,'directorIdReverse')">
                </FileUploader>
                <div v-if="error['directorIdReverse']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorIdReverse'])}}
                </div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('Holding ID Card') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(3)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(doc_type==0?'ic':'passport')+'_holding'" v-if="showPopup_3" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>

                <FileUploader  
                    :type="'browse'"
                    :ref="'directorIdHold'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    :default_image="params.directorIdHold"
                    @capture-file="captureFile($event,'directorIdHold')" 
                    @remove-image="removeImage($event,'directorIdHold')">
                </FileUploader>
                <div v-if="error['directorIdHold']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorIdHold'])}}
                </div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <label class="pt-2">{{ $t("Validity period of directors' certificates") }} <span class="text-danger">*</span></label>
                <date-picker v-model="params.directorCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('directorCertExpiryDate')"></date-picker>
                <div v-if="error['directorCertExpiryDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorCertExpiryDate'])}}
                </div>
            </b-col>

        </b-row>

        <b-row class="mb-4">
            <b-col cols="12" md="4">
                <div class="form-group mb-0">
                    <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="directorCountryCode" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country")}' class="form-control"/>
                    <div v-if="error['directorCountryCode']" class="invalid-feedback d-block mb-3">
                    {{$t(error['directorCountryCode'])}}
                    </div>
                </div>
            </b-col>

            <b-col md="4" cols="12">
                <div class="form-group mb-0">
                    <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.directorProvince" :options="stateOpt" @select="onSelectState($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("State")}' class="form-control"/>
                    <div v-if="error['directorProvince']" class="invalid-feedback d-block mb-3">
                        {{$t(error['directorProvince'])}}
                    </div>
                </div>
            </b-col>
            <b-col md="4" cols="12">
                <div class="form-group mb-0">
                    <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                    <input type="text" maxlength="58" v-model="params.directorCity" name="directorCity" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('directorCity')" autocomplete=off>
                    <div v-if="error['directorCity']" class="invalid-feedback d-block mb-3">
                        {{$t(error['directorCity'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-4">
            <b-col cols="12">
                <div class="form-group mb-0">
                    <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                    <input type="text" name="directorAddress" v-model="params.directorAddress" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                    <div v-if="error['directorAddress']" class="invalid-feedback d-block mb-3">
                        {{$t(error['directorAddress'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <input 
            type="checkbox" 
            autocomplete="off" 
            class="mt-2" 
            @change="onCheckboxChange($event)"
        > Same as profile information

    </div>


</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import Account from '@/services/Account';
import Common from '@/services/Common';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
    data() {
        return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            doc_type:0,
            nationality:'',
            showPopup_1:false,
            showPopup_2:false,
            showPopup_3:false,
            maxSize:4,
            success:null,
            lang_date:'en',
            directorCountryCode:'',
            countryOpt:[],
            stateOpt:[],
            optional:[],
            userNo:null,
            accountId:null,
            file:{
                directorIdFront: null,
                directorIdReverse: null,
                directorIdHold: null
            },
            params:{
                directorName: '',
                directorBirthDate: '',
                directorIdNo: '',
                directorIdType: '',     
                directorIdFront: '',
                directorIdReverse: '',
                directorIdHold: '',
                directorCertExpiryDate: '',
                directorProvince: '',
                directorCity: '',                
                directorCountryCode:'',
                directorAddress:''
            },
            error:{
                directorName: '',
                directorBirthDate: '',
                directorIdNo: '',
                directorIdType: '',     
                directorIdFront: '',
                directorIdReverse: '',
                directorIdHold: '',
                directorCertExpiryDate: '',
                directorProvince: '',
                directorCity: '',                
                directorCountryCode:'',
                directorAddress:''
            }
        }
    },
    components:{
        NewDocOption,
        FileUploader,
        Select2,
        NewPopupInfo,
        DatePicker
    },
    props:['doc_type_list','nationalityOpt','provinceOpt','information','index','user_no','account_id'],
    methods:{

        onCheckboxChange(event) {
        const isChecked = event.target.checked; // Mengecek apakah checkbox dicentang atau tidak
        if (isChecked) {

            Common.profile().then(response => {
                if(response.status == 200 && response.data.success){

                const profile = response.data.data;
                this.params.directorName = profile.fullname;
                this.params.directorCity = profile.city_name;
                

                if(profile.doc_type == 2){
                    const passportIndex = 1; 
                    this.$refs.doc_type.updateSelection(passportIndex); 
                } else {
                    const icIndex = 0; 
                    this.$refs.doc_type.updateSelection(icIndex); 
                }

                if(this.params.directorCountry){
                    var resultdata = this.onSelectCountry({"id":this.params.directorCountry});
                
                }

                if(this.params.directorProvince){
                    this.onSelectState({"id":this.params.directorProvince});
                }

                this.params.directorIdNo = profile.doc_id;
                this.params.directorBirthDate = profile.dob;

                }

            }).catch(err => {
                this.checkError(err);
            });

            } else {
                this.params.directorIdNo = '';
                this.params.directorBirthDate = '';
                this.params.directorName = '';
                this.params.directorCity = '';
                this.$refs.doc_type.updateSelection(0); 
            }
        },

        addressCondition($event){
            if($event.keyCode == 13){
                $event.preventDefault();
            }
            this.onChange('directorAddress');
        },
        onchangeAddress($event){
            let msg = $event.target.value.replace("\n", " ");
            $event.target.value = msg;
        },

        onSelectCountry({id,text,iso3}){

            var self = this;
            this.onChange('directorCountryCode');
            self.stateOpt = [];
            if(text){
                this.params.directorProvince="";
                this.params.directorCity="";
                this.params.directorCountryCode = iso3;
            }
            
            Common.states({"country_code":id}).then(response => {
                if(response.status == 200 && response.data.success){
                    const state = response.data.data;

                    for (let i = 0; i < state.length; i++) {
                    self.stateOpt.push({"id":state[i]['name'],"text":state[i]['name']});
                    }
                }
            });
        },
        onSelectState({id,text}){
            var self = this;
            this.onChange('directorProvince');
            if(text){
            this.params.directorCity="";
            }
        },

        onChange(name){
            this.error[name]="";
        },
        validate(){
            let success = true;
            let self = this;
            Object.keys(this.params).forEach(function(key) {
                if(self.params.directorIdType==2 && key == "directorIdReverse"){
                    self.error[key]="";
                }
                else if(!self.params[key] && !self.optional.includes(key)){
                    self.error[key]="can not be blank.";
                    success = false;
                }
            });

            return success;
        },
        getFile(index,file_id){
            let self = this;
            CreateAccount.getFile({fileId:file_id}).then(response => {
                let data_file = response.data.data[0];
                if(data_file.type == 2 || data_file.type == 5){
                    self.params.directorIdFront = data_file.file;
                    self.$refs['directorIdFront'].image = data_file.file;
                }
                else if(data_file.type == 4 || data_file.type == 6){
                    self.params.directorIdHold = data_file.file;
                    self.$refs['directorIdHold'].image = data_file.file;
                }
                else if(data_file.type == 3){
                    self.params.directorIdReverse = data_file.file;
                    self.$refs['directorIdReverse'].image = data_file.file;
                }
            });
        },
        uploadFile(){
            let self = this;
            this.success = null;

            this.error.directorIdFront='';
            this.error.directorIdHold='';
            this.error.directorIdReverse='';
            let fileList = [];

            if(self.params.directorIdFront.indexOf("base64")!=-1){
                fileList.push({
                    "type":(self.params.directorIdType==3 || self.params.directorIdType==4 || self.params.directorIdType==5)?2:5,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.directorIdFront
                });
            }
            if(self.params.directorIdHold.indexOf("base64")!=-1){
                fileList.push({
                    "type":(self.params.directorIdType==3 || self.params.directorIdType==4 || self.params.directorIdType==5)?4:6,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.directorIdHold
                });
            }

            if((self.params.directorIdType==3 || self.params.directorIdType==4 || self.params.directorIdType==5) && self.params.directorIdReverse.indexOf("base64")!=-1){
                fileList.push(
                    {
                        "type":3,
                        "maxSize":self.maxSize*1024*1024,
                        "file":self.params.directorIdReverse
                    }
                );
            }
            if(fileList.length>0){
                CreateAccount.uploadFile({
                    "accountId":self.accountId,
                    "userNo":""+self.userNo,
                    "fileUpload":fileList
                }).then(response => {
                    const data = response.data.data;
                    let fileList = data["file"];
                    for(let i=0;i<fileList.length;i++){
                        if(fileList[i].type==2 || fileList[i].type==5){
                            // self.params.directorIdFront = fileList[i].file;
                            self.file.directorIdFront = fileList[i].fileId;
                        }
                        else if(fileList[i].type==4 || fileList[i].type==6){
                            // self.params.directorIdHold = fileList[i].file;
                            self.file.directorIdHold = fileList[i].fileId;
                        }
                        else if(fileList[i].type==3){
                            // self.params.directorIdReverse = fileList[i].file;
                            self.file.directorIdReverse = fileList[i].fileId;
                        }
                    }
                    self.success = true;
                    self.$emit('file-uploaded');
                }).catch(err => {
                    self.checkError(err);
                });
            }
            else{
                self.success = true;
                self.$emit('file-uploaded');
            }
        },
        checkError(err){
            try{
                let self = this;
                const response = err.response;  
                if(response.status == 400 || response.status == 500){
                    if(typeof response.data.message === 'string'){
                        self.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.$t('OK')
                        });
                        self.$emit('on-error');
                    }
                    else{
                        if(response.data.message['file']){
                            let fileList = response.data.message['file'];
                            for(let i=0;i<fileList.length;i++){
                                if(fileList[i].type==2 || fileList[i].type==5){
                                    self.error.directorIdFront=fileList[i].message;
                                }
                                else if(fileList[i].type==4 || fileList[i].type==6){
                                    self.error.directorIdHold=fileList[i].message;
                                }
                                else if(fileList[i].type==3){
                                    self.error.directorIdReverse=fileList[i].message;
                                }
                            }
                        }
                        self.success = false;
                        self.$emit('on-error');
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }catch(e){
                console.log(err);
            }
        },
        togglePopup(index){
            this['showPopup_'+index]=!this['showPopup_'+index];
        },
        selectedDocument(selected_id){
            this.params.directorIdType = selected_id;
            this.error.directorIdType = "";
        },
        captureFile($event,key) {
            this.params[key]=$event;
            this.error[key]="";
        },
        removeImage($event,key){
            console.log($event);
            this.params[key]="";
            this.error[key] = "";
        },
        doEscapeMarkup(markup){
            return markup;
        }
    },
    mounted(){
        let self = this;
        Common.countries().then(response => {
          if(response.status == 200 && response.data.success){
            const countries=response.data.data;

            for (let i = 0; i < countries.length; i++) {
              const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
              const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
            
              self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"iso3":countries[i]['iso3']});
            }

            if(self.information){
                Object.keys(this.params).forEach(function(key) {
                    if(typeof self.file[key]!=="undefined" && self.information[key] && self.information[key][self.index]){
                        self.file[key]=self.information[key][self.index];
                        self.getFile(key,self.information[key][self.index]);
                    }
                    else if(typeof self.params[key] !== 'undefined' && self.information[key]) {
                        self.params[key]=self.information[key][self.index];
                    }
                });
                
                if(self.information['directorIdType']){
                    self.$refs['doc_type'].doc_type = parseInt(self.information['directorIdType'][self.index]);
                }
                else{
                    self.$refs['doc_type'].doc_type = "";
                }

                // set country
                for (let i = 0; i < this.countryOpt.length; i++) {
                    if(self.countryOpt[i]['iso3'] == self.params.directorCountryCode){
                        self.directorCountryCode = self.countryOpt[i]['id'];
                        break;
                    }
                }

                Common.states({"state_name":self.params['directorProvince']}).then(response => {
                    if(response.status == 200 && response.data.success){
                        const province = response.data.data;
                        for (let i = 0; i < province.length; i++) {
                            self.stateOpt.push({"id":province[i]['name'],"text":province[i]['name']});
                        }
                    }
                });
            }

            if(this.user_no){
                this.userNo = this.user_no;
                this.accountId = this.account_id;
            }
          }
        });
    }
}
</script>